import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { SyncUtils } from "../../utils/SyncUtils";
import { Grid } from "@mui/material";
import API from "../../utils/API";

export default forwardRef((props, ref) => {
  const { t } = useTranslation();
  const translate = t;

  const [ready, setReady] = useState(false);

  const refContainer = useRef(null);

  const [prodLookupValue, setProdLookupValue] = useState(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState(null);

  useEffect(() => {
    initComboBox();
  }, [props.value]);

  useEffect(() => {}, [props.saleData]);

  useEffect(() => {
    if (defaultOptions) {
      let selOption;

      for (let option of defaultOptions) {
        if (
          props.value.prodBean.id == option.value.id &&
          props.value.pricingBean.unitType == option.value.unitType
        ) {
          selOption = option;
        }
      }
      if (selOption) {
        setSelectedOption(selOption);
        prodSelected(selOption, false);
      }
    }
  }, [defaultOptions]);

  async function initComboBox() {
    if (props.value) {
      let opts = await await SyncUtils.searchInCache(
        props.productCache,
        props.value.prodBean.name,
        100
      );

      let opt = [];
      let selOption = null;
      for (let option of opts) {
        if (
          props.value.prodBean.id == option.id &&
          props.value.pricingBean.unitType == option.unitType
        ) {
          selOption = option;
        }
        opt.push({
          value: option,
          label: option,
        });
      }
      setDefaultOptions(opt);
      //setSelectedOption(selOption);
    }
  }

  useEffect(() => {
    refContainer.current.focus();
    setReady(true);
  }, []);

  useEffect(() => {}, [ready]);

  useEffect(() => {
    //if (prodLookupValue !== null) {
    //  props.stopEditing();
    // }
  }, [prodLookupValue]);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return prodLookupValue ? prodLookupValue.value : null;
      },
    };
  });

  const formatOptionLabel = (option, { context }) => {
    let strFactor = "";
    if (option?.value?.factor) {
      let factor = parseInt(option.value.factor);
      strFactor = "(" + factor + ")";
    }
    if (context === "menu") {
      return (
        <Grid container style={{ fontSize: "15px" }}>
          <Grid item xs={2}>
            {option.value.unitType} {strFactor}
          </Grid>
          <Grid item xs={5}>
            {option.value.name}
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            {option.value.currentStock}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {option.value.unitPrice} {props.context.store.currency}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };
  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };
  async function getOptionsAsync(inputValue, callback) {
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });

    let search = { and: [], or: [] };
    search.and.push({
      op: "eq",
      key: "productType",
      value: props.productType,
    });

    search.or.push({
      op: "contains",
      key: "code",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "name",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "code",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "sBarcodes",
      value: inputValue,
    });

    let { data } = await API.get(
      "/e_search/products?range=" +
        encodeURIComponent("[0,10]") +
        "&filter=" +
        encodeURIComponent(JSON.stringify(search)) +
        "&sort=" +
        encodeURIComponent(JSON.stringify(sort)) +
        "&showUnitTypes=true"
    );

    /*let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100,
      [props.productType],
      true,
      true
    );*/
    //console.log("arr", arr);
    return callback(
      data.data.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const productLookupChanged = (newValue) => {
    setSelectedOption(newValue);
    prodSelected(newValue, true);
  };

  async function prodSelected(newValue, newProdEvent) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modified, please Reload the Window");
    } else {
      //props.onAddProduct(prodBean, pricingBean);
      setProdLookupValue({
        label: prodBean.name,
        value: { prodBean: prodBean, pricingBean: pricingBean },
      });
      if (newProdEvent)
        props.onProductSelected(prodBean, pricingBean, props.data.id);
    }
  }

  return (
    <div
      style={{ width: 800 }}
      onKeyDown={(e) => {
        //e.stopPropagation();
        //e.nativeEvent.stopImmediatePropagation();
      }}
    >
      <AsyncSelect
        formatOptionLabel={formatOptionLabel}
        components={{ formatOptionLabel }}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 99999,
          }),
        }}
        placeholder={translate(
          props.prompt ? props.prompt : translate("Search or Scan the product")
        )}
        loadOptions={getOptions}
        defaultOptions={defaultOptions}
        onChange={productLookupChanged}
        onKeyDown={(e) => {
          //console.log("AsyncSelect keydown", e);
          e.stopPropagation();
        }}
        //value={prodLookupValue}
        value={selectedOption}
        ref={refContainer}
        //options={cities}
      />
    </div>

    /*<div
      ref={refContainer}
      style={mood}
      tabIndex={1} // important - without this the key presses wont be caught
    >
      <img
        src="https://www.ag-grid.com/example-assets/smileys/happy.png"
        onClick={() => {
          setHappy(true);
        }}
        style={happyStyle}
      />
      <img
        src="https://www.ag-grid.com/example-assets/smileys/sad.png"
        onClick={() => {
          setHappy(false);
        }}
        style={sadStyle}
      />
    </div>*/
  );
});
